var $8b8307f7979e9601$exports = {};
$8b8307f7979e9601$exports = {
    "removeButtonLabel": `Verwijderen`,
    "removeDescription": `Druk op Verwijderen om de tag te verwijderen.`
};


export {$8b8307f7979e9601$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
